<template>
  <div class="home-page h-100 w-100 d-flex fill-height primary">
    <section id="hero h-100 w-100 d-flex fill-height fill-width" style="width: 100%">
      <v-container fluid fill-height class="h-100">
        <v-row align="center" justify="center" class="text-left h-100">
          <v-col sm="6" md="4">
            <v-img src="/img/ScooprLaptop.png" style="margin-left: -50px; transform: scale(1.4);" alt="Searching for a new home with Scoopr"></v-img>
          </v-col>
          <v-col cols="10" offset="2" sm="6" offset-sm="0" md="3"
            class="white--text mb-5 pb-5"
            justify="space-between"
            style="z-index: 2"
          >
            <wordmarkLogo color="white" class="mb-5"/>
            <h1 class="text-xs-h5 text-sm-h4 text-md-h3 font-weight-bold mb-5">
              We help you win condos
            </h1>
            <p class="mb-5 pb-5 font-weight-bold">
              Bid with confidence
            </p>
            <p style="margin-bottom: -20px">
              <small class="text-overline font-weight-bold">Live in Vancouver?</small> <br />
              <v-btn large dark color="secondary" href="https://forms.gle/BqEjSutaNpJHn4ZRA" target="_blank">
                Sign up to be a tester
              </v-btn>
            </p>
          </v-col>
        </v-row>
      </v-container>
    </section>
    <!-- <section id="home-page-body">
      <v-parallax
        src="/img/VancouverLandscape.jpg"
        height="400"
      >
        <v-container>
          <v-row>
            <v-col class="text-center">
              <p class="text-h6">Looking for a condo in Vancouver?</p>
              <v-btn
                color="primary"
              >
                Sign up to be a tester
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-parallax>
    </section> -->
  </div>
</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'
import wordmarkLogo from '@/components/images/WordmarkLogo'

export default {
  name: 'Home',
  components: {
    wordmarkLogo
  }
}
</script>

<style lang="scss">
.vw-100 {
  width: 100vw !important;
}
.w-100 {
  width: 100% !important;
}
.h-100 {
  height: 100% !important;
}
.v-parallax__image-container{
  &:after {
    content: " ";
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba($color: #000000, $alpha: 0.4);
    z-index: 1;
  }
}

</style>
